import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DraggableAttributes } from '@dnd-kit/core'
import { zIndex } from '@/styles'

type SortItem = {
  id: string
}

type RenderProps = {
  listeners?: Record<string, Function>
  attributes?: DraggableAttributes
  style?: Record<string, string>
}

export type SortableItemProps = SortItem & {
  children: (props: RenderProps) => React.ReactNode
  useListeners?: boolean
}

const SortableItem: React.FC<SortableItemProps> = ({
  id,
  children,
  useListeners = true,
  ...rest
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id
  })
  const handleStyle = {
    touchAction: 'manipulation',
    ...(isDragging ? { cursor: 'grabbing' } : { cursor: 'grab' })
  }
  const style = {
    ...(useListeners ? handleStyle : {}),
    ...(isDragging ? { zIndex: zIndex.dragndrop } : {}),
    transform: CSS.Transform.toString(transform),
    transition
  }
  const events = useListeners ? { ...attributes, ...listeners } : {}
  return (
    <div ref={setNodeRef} style={style} {...events} {...rest}>
      {children({ listeners, attributes, style: handleStyle })}
    </div>
  )
}

export default SortableItem
